<template>
  <el-dialog
    title="商品标签"
    width="1000px"
    :visible="showModal"
    :mask-closable="false"
    @close="handleCancel"
    append-to-body
    :body-style="{ padding: '0px' }"
  >
    <div class="productContent">
      <div
        v-if="showTagRelation && isMultiSelect"
        :class="['toolbar', { cascade: groupSelected == 1 }]"
      >
        <div class="toolbar-right">
          <span class="toolbar-right-tips">*</span>
          <div class="toolbar-right-title">标签关系：</div>
          <el-radio-group v-model="groupSelected" @change="handleGroupChange">
            <el-radio :label="0">并列</el-radio>
            <el-radio :label="1">级联</el-radio>
          </el-radio-group>
        </div>
        <div v-if="groupSelected == 1">
          <el-select
            v-for="(item, index) in cascadeList"
            :key="index"
            clearable
            v-model="item.value"
            :placeholder="`请选择${numberToChinese(index + 1)}级`"
            size="mini"
            style="width: 170px; margin-left: 12px; margin-bottom: 8px"
          >
            <el-option
              v-for="option in cascadeOptions"
              :key="option.id"
              :label="option.name"
              :value="option.id"
              :disabled="isOptionDisabled(option.id, item.value)"
            />
          </el-select>
        </div>
      </div>
      <div class="toolbar">
        <div class="toolbar-right">
          <span class="toolbar-right-tips">*</span>
          <div class="toolbar-right-title">选择标签：</div>
          <bi-button type="blueLine" @click="toCreateTag"> 添加标签 </bi-button>
        </div>
        <div>
          <bi-button type="blueText" @click="handleRefresh"> 刷新 </bi-button>
          <bi-button type="blueText" class="ml12" @click="clearAll">
            一键清空
          </bi-button>
        </div>
      </div>
      <div v-loading="loading">
        <div class="table">
          <TagCategory
            v-for="item in list"
            :key="item.id"
            :category="item"
            :isMultiSelect="isMultiSelect"
            @change="updateCascade"
            @single-select="handleSingleSelect"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <div class="footerBtnBox">
        <!-- 移除了全局应用的复选框，让按钮居右对齐 -->
        <div style="flex: 1"></div>
        <span>
          <bi-button @click="handleSure" type="blue">确定</bi-button>
          <bi-button @click="handleCancel" type="gley">取消</bi-button>
        </span>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { queryTagList } from "@/api/bi/reviewReport/sectionConfig.js";
import cloneDeep from "lodash/cloneDeep";
import { mapMutations } from "vuex";
import TagCategory from "./TagCategory.vue";

export default {
  components: {
    TagCategory,
  },
  name: "ProductTagsDialog",
  props: {
    platformCompanySellerId: {
      type: [String, Array],
      default: "",
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    // 是否多店铺
    isMultiple: {
      type: Boolean,
      default: false,
    },
    nowShopList: {
      type: Array,
      default: () => [],
    },
    // 是否显示标签关系（并列/级联）
    showTagRelation: {
      type: Boolean,
      default: false,
    },
    // 商品标签分类类型
    tagClassifyType: {
      type: Number,
      default: 0,
    },
    // 商品标签分类列表
    tagClassifyList: {
      type: Array,
      default: () => [],
    },
    // 是否多选（false 时为单选模式）
    isMultiSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tagList: [],
      selectedTagIds: [],
      groupSelected: 0,
      loading: false,
      list: [],
      // 级联关系选择
      cascadeList: [],
      cascadeIds: [],
      cascadeRestored: false,
    };
  },
  computed: {
    // 当前已选择标签对应的分类
    selectedCategoryList() {
      const arr = [];
      this.list.forEach((category) => {
        const checked = category.itemTagList.some((tag) => tag.checked);
        if (checked) {
          arr.push({
            id: Number(category.id),
            name: category.name,
          });
        }
      });
      return arr;
    },
    // 下拉所有选项
    cascadeOptions() {
      return this.selectedCategoryList;
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        // this.queryTagListFn();
        this.selectedTagIds = cloneDeep(this.value);
        this.selectedTagIds = this.selectedTagIds.map((item) =>
          item.toString(),
        );
        if (!this.isMultiSelect && this.selectedTagIds.length > 1) {
          this.selectedTagIds = this.selectedTagIds.slice(0, 1);
        }
        this.groupSelected = this.isMultiSelect ? this.tagClassifyType : 0;
        this.cascadeIds = cloneDeep(this.tagClassifyList).map((item) =>
          Number(item),
        );
        this.cascadeList = [];
        this.cascadeRestored = false;
        this.getList();
      }
    },
    platformCompanySellerId: {
      handler(newVal, oldVal) {
        if (this.isMultiple) {
          let val1, oldVal1;
          if (oldVal === undefined || newVal === []) {
            return;
          }
          if (newVal instanceof Array && oldVal instanceof Array) {
            val1 = newVal.join(",");
            oldVal1 = oldVal.join(",");
          }
          if (val1 == oldVal1 && oldVal && newVal.length == oldVal.length) {
            return;
          }
          if (newVal.length <= 0) {
            return;
          }
          this.queryTagListFn();
        } else {
          if (newVal !== oldVal) {
            this.queryTagListFn();
          }
        }
      },
      immediate: true,
    },
    selectedCategoryList: {
      deep: true,
      handler(val) {
        // 不开启标签关系功能
        if (!this.showTagRelation) {
          this.cascadeList = [];
          return;
        }
        if (this.groupSelected != 1) {
          this.cascadeList = [];
          return;
        }
        const ids = val.map((item) => item.id);
        // 删除已经不存在的分类
        this.cascadeList = this.cascadeList.filter((item) =>
          ids.includes(item.value),
        );
        // 2. 新增分类，只追加，不改变原顺序
        val.forEach((item) => {
          const exist = this.cascadeList.some((c) => c.value === item.id);
          if (!exist && this.cascadeList.length < 5) {
            this.cascadeList.push({
              value: item.id,
              name: item.name,
            });
          }
        });
        if(val.length > 5) {
          // 级联关系选择不能超过5个-禁用未选择的分类
          let disabledSelectList = this.cascadeList.map((item) => item.value.toString());
          this.list.forEach((item) => {
            if(!disabledSelectList.includes(item.id)) {
              item.itemTagList.forEach((obj) => {
                obj.checked = false;
              });
            }
          });
            this.$message({
              message: "标签关系为「级联」时，所选标签的分类不能超过5个哦~",
              type: "warning",
            });
          }
        // 回显已选择的分类值（仅首次打开时执行一次）
        if (!this.cascadeRestored && this.cascadeIds.length > 0) {
          this.cascadeList.forEach((item, index) => {
            if (index < this.cascadeIds.length) {
              item.value = this.cascadeIds[index];
            }
          });
          this.cascadeRestored = true;
        }
      },
    },
  },
  async mounted() {
    // await this.queryTagListFn();
  },
  methods: {
    ...mapMutations(["SET_TAG_OPTIONS"]),
    numberToChinese(num) {
      const chinese = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
      ];
      return chinese[num - 1] || num;
    },
    isOptionDisabled(id, currentValue) {
      // 当前下拉自己的值不能禁用
      if (id === currentValue) {
        return false;
      }
      // 被其它下拉选择
      return this.cascadeList.some((item) => item.value === id);
    },
    handleSingleSelect(currentItem) {
      this.list.forEach((category) => {
        const inThis = category.itemTagList.some(
          (t) => t.id === currentItem.id,
        );
        if (!inThis) {
          category.itemTagList.forEach((t) => {
            t.checked = false;
          });
        }
      });
    },
    handleGroupChange(val) {
      if(this.selectedCategoryList.length > 5) {
        this.groupSelected = 0;
        this.$message({
          message: "所选标签分类超过5个时，标签关系不支持切换为「级联」，请减少所选标签分类后再切换哦~",
          type: "warning",
        });
        return
      }
      if (!this.showTagRelation) {
        return;
      }
      if (val != 1) {
        this.cascadeList = [];
        return;
      }
      this.cascadeList = this.selectedCategoryList.slice(0, 5).map((item) => ({
        value: item.id,
        name: item.name,
      }));
      
    },
    updateCascade() {
      if (this.groupSelected == 1) {
        this.$forceUpdate();
      }
    },
    handleRefresh() {
      this.loading = true;
      this.queryTagListFn();
    },
    toCreateTag() {
      // 请根据实际环境或路由修改此处的跳转链接
      if (window.location.origin.includes("yqbi.yucrm.cn")) {
        window.open(
          "https://yqbi.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage",
          "_blank",
        );
      } else {
        window.open(
          "http://yqbi-test.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage",
          "_blank",
        );
      }
    },
    async queryTagListFn() {
      try {
        let params = {
          platformCompanySellerIdStr: Array.isArray(
            this.platformCompanySellerId,
          )
            ? this.platformCompanySellerId.join(",")
            : this.platformCompanySellerId || "",
        };
        if (this.isMultiple) {
          if (!this.platformCompanySellerId.join(",")) {
            params = {
              platformCompanySellerIdStr: this.nowShopList.join(",") || "",
            };
          } else {
            params = {
              platformCompanySellerIdStr:
                this.platformCompanySellerId.join(",") || "",
            };
          }
        }
        const res = await queryTagList(params);
        if (res.code === 200 || res.code === 1) {
          this.tagList = res.data || [];
          this.getList();
          this.SET_TAG_OPTIONS(this.tagList);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    getList() {
      this.list = this.tagList.map((item) => ({
        ...item,
        expand: false,
        keyword: "",
        itemTagList: item.itemTagList.map((tag) => ({
          ...tag,
          checked: false,
        })),
      }));
      this.list.forEach((category) => {
        category.itemTagList.push({
          id: category.id + "-0",
          name: "无标项",
          checked: false,
        });
      });
      if (this.selectedTagIds.length > 0) {
        this.list.forEach((category) => {
          category.itemTagList.forEach((tag) => {
            if (this.selectedTagIds.includes(tag.id)) {
              tag.checked = true;
            }
          });
        });
      }
    },
    clearAll() {
      this.list.forEach((c) => {
        c.itemTagList.forEach((t) => {
          t.checked = false;
        });
      });
      this.cascadeList = [];
    },
    handleSure() {
      const ids = [];
        this.list.forEach((category) => {
          category.itemTagList.forEach((tag) => {
            if (tag.checked) {
              ids.push(tag.id);
            }
          });
        });
      // 级联关系校验
      let cascadeIds = [];
      let cascadeNames = [];
      if (this.showTagRelation && this.groupSelected == 1) {
        if (ids.length == 0) {
          this.$message.warning("请选择商品标签");
          return;
        }
        const emptyItem = this.cascadeList.some((item) => !item.value);
        if (emptyItem) {
          this.$message.warning("请选择级联的关联关系选项");
          return;
        }
        cascadeIds = this.cascadeList.map((item) => item.value);
        cascadeIds.forEach((item,index) => {
          const name = this.cascadeOptions.find((option) => option.id == item).name;
          if(name) {
            cascadeNames.push(name);
            this.cascadeList[index].name = name;
          }
        })
      }
      this.$emit("update:showModal", false);
      this.$emit("confirm", ids, this.groupSelected, cascadeIds, cascadeNames);
    },
    handleCancel() {
      this.$emit("update:showModal", false);
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: PingFang SC, PingFang SC;
}
.footerBtnBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  &.cascade {
    justify-content: flex-start;
    align-items: flex-start;
  }
  .toolbar-right {
    height: 32px;
    display: flex;
    align-items: center;
    font-size: 14px;
    flex-shrink: 0;
    &-tips {
      color: #ff304f;
    }
    &-title {
      color: #333333;
    }
  }
}

.table {
  border: 1px solid #ebeef5;
  max-height: 500px;
  overflow: auto;
}
.footerBtnBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .checkText {
    color: #666666;
    font-weight: 400;
  }
}
.ml12 {
  margin-left: 12px !important;
}
:deep(.el-select .el-input.is-focus .el-input__inner) {
  background: #ffff;
  color: #333333;
  border-radius: 2px;
  border: 1px solid #3159ff;
}
:deep(.el-input input:hover) {
  border: 1px solid #3159ff;
}
:deep(.el-select .el-input__inner:focus) {
  border: 1px solid #3159ff;
}
:deep(.el-input--mini .el-input__icon) {
  line-height: 30px;
}
</style>
